import React, {useState, useCallback, useEffect} from 'react';
import PropTypes from 'prop-types';
import {useList} from 'react-use';
import {useDispatch, shallowEqual, useSelector} from 'react-redux';

import Select from '../../../../components/Select';
import ColorPicker from '../../../../components/ColorPicker';
import useDisableScrollDocument from '../../../../useHook/useDisableScrollDocument';
import {SelectAsyncWrapper} from '../../../../components/Select';
import {getPlayers, getPlayerDetail} from "../../../../actions/leader-board";
import SearchPlayer from '../../game/SearchPlayer';

function SettingModal(props) {
    useDisableScrollDocument();
    const dispatch = useDispatch();

    const [selectedConfig, setSelectedConfig] = useState({
        xColumn: null,
        yColumn: null,
        xUnits: null,
        itemType: null,
    });
    const [notFoundPlayer, setNotFoundPlayer] = useState(false);
    const teams = useSelector(state => state.metadata.teams, shallowEqual);

    const [colors, colorsHelper] = useList([
        {item: null, color: '#EEEEEE'},
        {item: null, color: '#EEEEEE'},
    ]);

    useEffect(() => {
        if(!props.selected) return;
        const xColumn = props.configs.x_columns.find(column => column.value === props.selected.x_column);
        const yColumn = props.configs.y_columns.find(column => column.column === props.selected.y_column);
        const xUnits = props.configs.x_units.find(column => column.value === props.selected.x_unit);
        const itemType = props.configs.item_types.find(column => column.value === props.selected.item_type);
        setSelectedConfig({
            xColumn,
            yColumn,
            xUnits,
            itemType,
        });
        colorsHelper.clear();
        if(props.selected.items.length > 0 && itemType.value === 'player_id') {
            const ids = props.selected.items.map(item => item.item);
            getPlayerInfo(ids).then((listPlayer) => {
                const list = [];
                props.selected.items.forEach(item => {
                    const player = listPlayer.find(player => player.id === item.item);
                    list.push({
                        item: player,
                        color: item.color,
                    });
                });
                if(list.length === 1) {
                    list.push({item: null, color: '#EEEEEE'})
                }
                colorsHelper.set(list);
            });
            return;
        }
        const items = props.selected.items.map(item => {
            const team = teams.find(team => team.id === item.item) || {};
            return {
                ...item,
                item: {
                    id: item.item,
                    team_name_s: team.team_name_s,
                }
            }
        });
        if(items.length === 1) {
            items.push({item: null, color: '#EEEEEE'})
        }
        colorsHelper.set(items);
    }, [props.selected]);

    const getPlayerInfo = useCallback(async (ids) => {
        if(ids.length === 0) {
            return Promise.resolve([]);
        }
        try {
            const players = await dispatch(getPlayerDetail(ids));
            return players;
        }catch (error) {
            return [];
        }
    }, []);

    const onChangeSelected = useCallback((field, value) => {
        setSelectedConfig({
            ...selectedConfig,
            [field]: value,
        })
    }, [selectedConfig]);

    const onSave = useCallback(() => {
        const selectedValue = {
            items: [],
        };

        colors.forEach(item => {
            if(!item.item) return;
            selectedValue.items.push({
                item: item.item.id,
                color: item.color,
            });
        });

        if(selectedConfig.xColumn) {
            selectedValue['x_column'] = selectedConfig.xColumn.value;
        }
        if(selectedConfig.yColumn) {
            selectedValue['y_column'] = selectedConfig.yColumn.column;
        }
        if(selectedConfig.xUnits) {
            selectedValue['x_unit'] = selectedConfig.xUnits.value;
        }
        if(selectedConfig.itemType) {
            selectedValue['item_type'] = selectedConfig.itemType.value;
        }
        props.onSave(selectedValue);
    }, [selectedConfig, colors]);

    const onLoadOptions = useCallback(async (inputValue, callback) => {
        try {
            setNotFoundPlayer(true);
            const result = await dispatch(getPlayers({
                keyword: inputValue,
                teamIds: [],
            }));
            setNotFoundPlayer(false);
            callback(result);
        }catch (error) {
            callback([]);
        }
    }, []);

    return <div className={'dsa-modal-wrapper'}>
        <div className={'dsa-modal-content'}>
            <h4 className={'dsa-modal-title'}>
                グラフ設定
            </h4>
            <div style={{paddingTop: 15, paddingBottom: 15}}>
                <div style={{display: 'flex'}}>
                    <div style={{width: 'calc(100% / 3)'}}>
                        <div style={{color: '#74818A', paddingBottom: 5}}>
                            X軸
                        </div>
                        <Select value={selectedConfig.xColumn}
                                options={props.configs.x_columns}
                                placeholder={'シーズン'}
                                getOptionValue={option => option.value}
                                getOptionLabel={option => option.name}
                                styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                menuPosition={'fixed'}
                                onChange={(value) => onChangeSelected('xColumn', value)}
                        />
                    </div>
                    <div style={{width: 'calc(100% / 3)', paddingLeft: 15}}>
                        <div style={{color: '#74818A', paddingBottom: 5}}>
                            Y軸
                        </div>
                        <Select value={selectedConfig.yColumn}
                                options={props.configs.y_columns}
                                placeholder={'シーズン'}
                                getOptionValue={option => option.column}
                                getOptionLabel={option => option.name}
                                styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                menuPosition={'fixed'}
                                onChange={(value) => onChangeSelected('yColumn', value)}
                        />
                    </div>
                    <div style={{width: 'calc(100% / 3)', paddingLeft: 15}}>
                        <div style={{color: '#74818A', paddingBottom: 5}}>
                            目盛
                        </div>
                        <Select value={selectedConfig.xUnits}
                                options={props.configs.x_units}
                                placeholder={'試合'}
                                getOptionValue={option => option.value}
                                getOptionLabel={option => option.name}
                                styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                menuPosition={'fixed'}
                                onChange={(value) => onChangeSelected('xUnits', value)}
                        />
                    </div>
                </div>
                <div style={{paddingTop: 30, width: '50%'}}>
                    <div style={{color: '#74818A', paddingBottom: 5}}>
                        対象
                    </div>
                    <Select value={selectedConfig.itemType}
                            options={props.configs.item_types}
                            placeholder={'シーズン'}
                            getOptionValue={option => option.value}
                            getOptionLabel={option => option.name}
                            styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                            menuPosition={'fixed'}
                            onChange={(value) => onChangeSelected('itemType', value)}
                    />
                </div>
                <div style={{paddingTop: 15}}>
                    {colors.map((item, index) => {
                        return <div key={index} style={{display: 'flex', paddingBottom: 15, justifyContent: 'space-between'}}>
                            <div style={{flex: 1}}>
                                {selectedConfig.itemType && selectedConfig.itemType.value === 'team_id' && <div>
                                    <Select
                                        value={item.item}
                                        options={teams}
                                        placeholder={'球団選択'}
                                        getOptionValue={option => option.id}
                                        getOptionLabel={option => option.team_name_s}
                                        styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                        menuPosition={'fixed'}
                                        onChange={(value) => colorsHelper.updateAt(index, {...item, item: value})}
                                    />
                                </div>}
                                {selectedConfig.itemType && selectedConfig.itemType.value === 'player_id' && <div>
                                    <SearchPlayer
                                        placeholder='選手選択'
                                        teamIds={[]}
                                        fullWidth
                                        selected={item.item ? {
                                            playerName:  item.item.player_name,
                                            id:  item.item.id,
                                        }: null}
                                        onChoosePlayer={(value) => {
                                            // console.log('value', value);
                                            colorsHelper.updateAt(index, {...item, item: {
                                                id: value.id,
                                                player_name: value.player_name,
                                            }});
                                        }}
                                    />
                                </div>}
                            </div>
                            <div style={{paddingLeft: 15, paddingBottom: 5}}>
                                <ColorPicker
                                    color={item.color}
                                    onChange={(color) => {
                                        // console.log(item);
                                        colorsHelper.updateAt(index, {...item, color: color});
                                    }}
                                />
                            </div>
                        </div>
                    })}
                </div>
            </div>
            <div className={'dsa-footer-topic'}>
                <button className={'dsa-button-modal'}
                        onClick={props.onClose}>
                    キャンセル
                </button>
                <button className={'dsa-button-modal'}
                        onClick={onSave}>
                    更新
                </button>
            </div>
        </div>
    </div>
}

SettingModal.propTypes = {
    configs: PropTypes.object,
    onClose: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired,
};

export default SettingModal;
